import styled from 'styled-components'

export default styled.div`
 {
   display: flex;
   justify-content: space-between;
   border-bottom: 1px solid #e5e5e5;
   font-family: 'PT Sans', sans-serif;
   .brand {
     width: 50%;
     font-size: 1.3em;
   }
   .nav {
     width: 50%;
     padding-top: 50px;
     padding-bottom: 0px;
     display: flex;
     justify-content: flex-end;
     span {
       padding-left: 10px;
       padding-right: 10px;
     }
     .nav-links {
       font-size: 1.3em;
       color: grey;
       text-decoration: none;
     }
     .nav-active {
       color: black;
     }
   }
 }
@media (max-width: 768px) {
  flex-direction: column;
  border-top: 1px solid #e5e5e5;
  .brand {
    width: 100%;
    text-align: center;
  }
  .nav {
    width: 100%;
    padding-top: 0px;
    padding-bottom: 8px;
    display: flex;
    justify-content: center;
    span {
      padding-left: 10px;
      padding-right: 10px;
    }
}
@media (max-width: 992px) {}
@media (max-width: 1200px) {}
`



// WEBPACK FOOTER //
// ./src/styles/StyledHeader.js